/**
 * Created by or_p on 7/23/2016.
 */
import _ from 'lodash';

const CHILD_ID_SEPERATOR = '_child_';
function getChildId(element, index) {
  return `${element.id}${CHILD_ID_SEPERATOR}${index}`;
}

export function getParentIdFromChildId(childId) {
  if (!_.isNil(childId)) {
    const splitId = childId.split(CHILD_ID_SEPERATOR);
    if (splitId.length === 2) {
      return splitId[0];
    }
  }
  return null;
}

export function initChildElements(element) {
  if (_.get(element, 'data.children')) {
    _.forEach(element.data.children, (child, index) => {
      element.data.children[index] = {
        ...child,
        id: getChildId(element, index),
        parentId: element.id,
        parentType: element.type,
        locked: true
      };
    });
  }
}

export function getNestedChildrenUpdate(elementId, elements, update) {
  const parentId = getParentIdFromChildId(elementId);
  if (parentId) {
    const childIndex = _.findIndex(elements[parentId].data.children, (element) => (element.id === elementId));
    return {
      [parentId]: {
        data: {
          children: {
            [childIndex]: update
          }
        }
      }
    };
  }
  return null;
}

export function getNestedChildrenUpdateByAction(elementId, elements, action) {
  return getNestedChildrenUpdate(elementId, elements, {
    data: {
      $merge: action.elementProps.data
    }
  });
}


export function getChildrenElementsUpdate(element, action) {

  const childrenFromAction = _.get(action, 'elementProps.data.children');
  const children = [];
  if (childrenFromAction) {
    childrenFromAction.forEach((child, index) => {
      children.push({
        ..._.omit(child, 'parent'),
        id: getChildId(element, index),
        parentId: element.id,
        parentType: element.type,
        locked: true
      });
    });
    return {
      [element.id]: {
        data: {
          children: {
            $set: children,
          },
          tabNames: {
            $set: action.elementProps.data.tabNames,
          },
        }
      }
    };
  }
  return null;
}
